<template>
    <transition appear name="next" mode="out-in">
        <div v-if="active" :class="'layout-ui-message '+type" @click="active=false">
            <h1>{{ title }}</h1>
            <p v-html="message"></p>
        </div>
    </transition>
</template>
<script>
export default {
    
    name: 'UiMessage',
    
    data()
    {
        return {
            active:  false,
            title:   false,
            message: false,
            type:    false
        }
    },
    
    created()
    {
        
        this.$core.getEventManager()
            .add( 'on-ui-message', ( payload ) =>
            {
                this.handleMessage( payload )
            } )
        
        this.$core.getEventManager()
            .append( 'on-websocket-error', ( payload ) =>
            {
                this.handleWebsocketError( payload )
            } )
    },
    
    beforeUnmount()
    {
        this.$core.getEventManager()
            .remove( 'on-ui-message' )
    },
    
    methods: {
        
        reset()
        {
            this.active = false
            this.title = false
            this.message = false
            this.type = false
        },
        
        handleMessage( payload )
        {
            this.active = true;
            this.title = payload.title;
            this.message = payload.message;
            this.type = payload.type;
            
            this.$core.getCoreTimer()
                .addTimeout( 'hide-ui-message', 20000, () =>
                {
                    this.reset()
                } )
        },
        
        handleWebsocketError()
        {
            this.active = true
            this.title = 'Holla die Waldfee: Es gab ein Problem!'
            this.message = 'Bei der Kommunikation mit den Lovepod-Servern kam es zu einem Fehler: Wir bitten dies zu entschuldigen!<br/>Versuche nochmal, was du zuletzt getan hast - anderenfalls halte durch: Serverfehler werden unserem Admin-Team automatisch mitgeteilt.'
            this.type = 'error'
            
            this.$core.getCoreTimer()
                .addTimeout( 'hide-error-message', 20000, () =>
                {
                    this.reset()
                } )
        }
        
    }
    
}
</script>